import template from './cost_center.all.html';
import controller from './cost_center.all.controller';
import './cost_center.all.scss';

let CostCenterAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template,
    controller
};

export default CostCenterAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/all/cost_center.all.component.js